<template>
    <button class="rounded-full border border-tc-blue-1 bg-white text-center w-full h-45px"
            :class="[setPadding , isDisabled ? 'border-tc-gray-1 bg-tc-gray-4 text-black' : 'text-tc-blue-1']">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'OutlineBlueBtn',
    props: {
        paddingClass:   { type: String, default: '' },
        isDisabled:     { type: Boolean, default: false }
    },
    computed: {
        setPadding: function() {
            if (this.paddingClass == '') {
                return 'p-1';
            }
            return this.paddingClass;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
